import { useEffect, useState } from "react";
import {
  resolveDefaultPaymentMethodId,
  type PaymentMethodId,
} from "@/lib/paymentMethods";

export function useSelectedPaymentMethod(acceptedIds: PaymentMethodId[]) {
  const [paymentMethodId, setPaymentMethodId] = useState<PaymentMethodId>(() =>
    resolveDefaultPaymentMethodId(acceptedIds)
  );

  useEffect(() => {
    if (!acceptedIds.includes(paymentMethodId)) {
      setPaymentMethodId(resolveDefaultPaymentMethodId(acceptedIds));
    }
  }, [acceptedIds, paymentMethodId]);

  return [paymentMethodId, setPaymentMethodId] as const;
}
